import { ApiRoutes } from "./types";

export const API_ROUTES: ApiRoutes = {
  LOGIN: '/api/v1/auth/login/',
}
